const DOM = {
    modalIcon: ".modal__icon",
    modalTitle: ".modal__title",
    modalDescription: ".modal__description",
}

export default function genericErrorModal(data) {
    const modalIconEl = document.querySelector(DOM.modalIcon);
    const modalTitleEl = document.querySelector(DOM.modalTitle);
    const modalDescriptionEl = document.querySelector(DOM.modalDescription);

    if(data.icon) {
        modalIconEl.innerHTML = data.icon;
    }
    if(data.title) {
        modalTitleEl.innerText = data.title;
    } else {
        modalTitleEl.innerHTML = "Algo de errado aconteceu!"
    }
    if(data.description) {
        modalDescriptionEl.innerText = data.description;
    } else {
        modalDescriptionEl.innerText = "Entre em contato conosco";
    }
}
